<template>
  <a-modal :title="$t('investorList.jkrmx')" :width="1000" :visible="visible" :footer="null" @cancel="handleCancel">
    <div class="borrower-detail-container">
      <div class="search-form">
        <a-form layout="inline">
          <a-form-item>
            <a-input-group compact>
              <a-select v-model="queryParam.searchType" style="width: 130px">
                <a-select-option value="loanerName">{{ $t('investorList.jkrmc') }}</a-select-option>
                <a-select-option value="loanerId">{{ $t('investorList.jkrid') }}</a-select-option>
                <a-select-option value="loanerMobile">{{ $t('investorList.jkrsjh') }}</a-select-option>
              </a-select>
              <a-input v-model="queryParam.searchValue" style="width: 180px" :placeholder="$t('enter')" />
            </a-input-group>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
          </a-form-item>
        </a-form>
      </div>

      <a-table
        bordered
        :columns="columns"
        :data-source="dataSource"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        rowKey="id"
      >
        <span slot="mobile" slot-scope="text">
          {{ text | maskPhone }}
        </span>
        <span slot="investAmount" slot-scope="text">
          {{ text | FenToDong }}
        </span>
        <span slot="investDuration" slot-scope="text">
          {{ text }}
        </span>
        <span slot="investYieldRate" slot-scope="text"> {{ text }}% </span>
        <span slot="investLoanStatus" slot-scope="text">
          {{ loanStatusFilter(text) }}
        </span>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { getBorrowerList } from '@/webpublicapi/vietnamBackstage'

export default {
  name: 'BorrowerDetailModal',
  data() {
    return {
      visible: false,
      loading: false,
      investId: undefined,
      queryParam: {
        searchType: 'loanerName',
        searchValue: '',
        id: '',
        mobile: '',
      },
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
      },
    }
  },
  computed: {
    columns() {
      return [
        { title: this.$t('investorList.jkrmc'), dataIndex: 'realName', width: 160 },
        {
          title: this.$t('investorList.jkrsjh'),
          dataIndex: 'mobile',
          scopedSlots: { customRender: 'mobile' },
          width: 160,
        },
        {
          title: this.$t('investorList.jkje'),
          dataIndex: 'investAmount',
          scopedSlots: { customRender: 'investAmount' },
          width: 160,
        },
        {
          title: this.$t('investorList.jkqx'),
          dataIndex: 'investDuration',
          scopedSlots: { customRender: 'investDuration' },
          width: 140,
        },
        {
          title: this.$t('investorList.jkzt'),
          dataIndex: 'investLoanStatus',
          scopedSlots: { customRender: 'investLoanStatus' },
          width: 140,
        },
        {
          title: this.$t('investorList.nhll'),
          dataIndex: 'investYieldRate',
          scopedSlots: { customRender: 'investYieldRate' },
          width: 140,
        },
      ]
    },
  },
  methods: {
    // Phone number masking
    maskPhone(phone) {
      if (!phone) return ''
      const phoneStr = String(phone)
      if (phoneStr.length <= 7) return phoneStr
      return phoneStr.substring(0, 3) + '****' + phoneStr.substring(phoneStr.length - 4)
    },
    show(investId) {
      this.visible = true
      this.investId = investId
      this.pagination.current = 1
      this.queryParam.searchValue = ''
      this.loadData()
    },
    handleCancel() {
      this.visible = false
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    loanStatusFilter(status) {
      const map = {
        '-1': this.$t('investorList.lb'),
        0: this.$t('investorList.ddk'),
        1: this.$t('investorList.jkz'),
        2: this.$t('investorList.hkz'),
        3: this.$t('investorList.ywc'),
      }
      return map[status] || status
    },
    loadData() {
      if (!this.investId) {
        this.dataSource = []
        this.pagination.total = 0
        return
      }

      this.loading = true
      const params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        investId: this.investId,
      }

      if (this.queryParam.searchValue) {
        if (this.queryParam.searchType === 'loanerName') {
          params.loanerName = this.queryParam.searchValue
        } else if (this.queryParam.searchType === 'loanerId') {
          params.loanerId = this.queryParam.searchValue
        } else if (this.queryParam.searchType === 'loanerMobile') {
          params.loanerMobile = this.queryParam.searchValue
        }
      }

      getBorrowerList(params)
        .then((res) => {
          if (res.success && res.respData) {
            const { records, total, current } = res.respData
            this.dataSource = records || []
            this.pagination.total = total || 0
            this.pagination.current = current || 1
          } else {
            this.dataSource = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.borrower-detail-container {
  padding: 10px 20px;

  .search-form {
    margin-bottom: 16px;
  }
}
</style>
